<template>
  <section class="bss">
    <div class="bss__head">
      <h3 class="bss__title">{{ lang.sender_section_title || 'E-mail sender' }}</h3>
      <p class="bss__text">{{ lang.sender_section_text }}</p>
    </div>
    <SegmentedTabs class="bss__mode" size="sm" :tabs="modeTabs" :value="mode" @input="$emit('update:mode', $event)" />
    <div v-if="mode === 'custom'" class="bss__grid">
      <CustomInput
          :label="lang.sender_name || 'Sender name'"
          :placeholder="lang.sender_name_placeholder || ''"
          :value="senderName"
          @input="$emit('update:senderName', $event)" />
      <CustomInput
          :label="lang.sender_email || 'Sender e-mail'"
          :placeholder="lang.sender_email_placeholder || ''"
          type="email"
          :value="senderEmail"
          @input="$emit('update:senderEmail', $event)" />
    </div>
    <p v-else class="bss__default">{{ lang.sender_default_info || 'All e-mails of this branding are sent as' }} <strong>{{ defaultLabel || '—' }}</strong></p>
  </section>
</template>

<script>
import CustomInput from '../parts/CustomInput.vue';
import SegmentedTabs from '../parts/SegmentedTabs.vue';

/**
 * Per-branding e-mail sender (brandings.sender_name / sender_email).
 * Own section in the branding dialog: title + per-language explanation + a
 * toggle "Standard sender <address>" | "Custom sender" (name + e-mail inputs).
 * `mode` is UI state only: 'default' saves both fields as NULL, 'custom' saves
 * the inputs. Saved by the "General" tab's Save in editBrand.vue.
 * The backend validates and builds the From header (expressApi/src/email/brandingSender.js).
 */
export default {
  name: 'BrandingSenderSection',
  components: { CustomInput, SegmentedTabs },
  props: {
    options: { type: Object, required: true },
    mode: { type: String, default: 'default' },      // 'default' | 'custom' (.sync)
    defaultName: { type: String, default: '' },      // the global sender, display only
    defaultEmail: { type: String, default: '' },
    senderName: { type: String, default: '' },
    senderEmail: { type: String, default: '' },
  },
  computed: {
    lang() {
      return (this.options && this.options.Lang) || {};
    },
    // "Name · address" (or just one of them): nothing else.
    defaultLabel() {
      return [this.defaultName, this.defaultEmail].filter(Boolean).join(' · ');
    },
    modeTabs() {
      return [
        { value: 'default', label: this.defaultLabel || (this.lang.sender_mode_default || 'Standard sender'), icon: 'mail' },
        { value: 'custom', label: this.lang.sender_mode_custom || 'Custom sender', icon: 'edit' },
      ];
    },
  },
};
</script>

<style scoped>
.bss { margin-top: 2rem; padding-top: 1.5rem; border-top: 1px solid #e6e6e6; }
.bss__head { margin-bottom: 1rem; max-width: 900px; }
.bss__title { margin: 0 0 0.4rem; font-size: 1.05rem; font-weight: 700; color: #202224; }
.bss__text { margin: 0; font-size: 0.85rem; line-height: 1.5; color: #666; }
.bss__mode { display: inline-flex; margin-bottom: 1.25rem; }
.bss__default { margin: 0; font-size: 0.9rem; color: #444; }
.bss__grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 1.25rem 1.5rem; }
@media (max-width: 1100px) { .bss__grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (max-width: 700px)  { .bss__grid { grid-template-columns: 1fr; } }
</style>
